/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */
import React, { Component } from 'react';

/**
 * Shared 24x7 technical support / call center contact block rendered on the login
 * (username/password) and trusted-account (Entra) login pages. Extracted so the markup
 * lives in a single place rather than being duplicated across both pages.
 */
export class SupportContactInfo extends Component {

    render() {
        return (
            <React.Fragment>
                <div className='support-data'>
                    <span>
                        24 x 7 Technical Support and Call Center Access are available from&nbsp;
                        <a target="_blank"
                           rel="noopener noreferrer"
                           style={{color:"#0058e4"}}
                           href="https://merative.my.site.com/mysupport/s/micromedex-support-request">
                            Micromedex Support
                        </a>
                    </span>
                </div>
                <div className='support-data'>
                    <span>
                        U.S. and Canada Phone: 1-877-843-6796
                        <br/>
                        Global: +1.734.768.1510
                        <br/>
                        <a target="_blank"
                           rel="noopener noreferrer"
                           style={{color:"#0058e4"}}
                           href="https://www.merative.com/contact">
                            Contact Us
                        </a>
                    </span>
                </div>
            </React.Fragment>
        );
    }
}

export default SupportContactInfo;

